import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import "./fallback.css";

export default function RevenueNoData() {
    // Try to read company from URL: /revenue_teardown/<Company>/<Competitor?>
    const companyFromUrl = useMemo(() => {
        try {
            const parts = window.location.pathname.split("/").filter(Boolean);
            const idx = parts.findIndex(p => p === "revenue_teardown");
            if (idx >= 0) {
                const comp = parts[idx + 1] ? decodeURIComponent(parts[idx + 1]) : "";
                const competitor = parts[idx + 2] ? decodeURIComponent(parts[idx + 2]) : "";
                return { company: comp, competitor };
            }
        } catch { }
        return { company: "", competitor: "" };
    }, []);

    const companyLabel =
        companyFromUrl.competitor || companyFromUrl.company || "this company";

    return (
        <div className="no-data-page d-flex align-items-center justify-content-center min-vh-100">
            <div className="no-data-card text-center">
                {/* Icon */}
                <div className="no-data-icon mb-3">
                    <svg viewBox="0 0 200 200" className="no-data-svg" aria-hidden="true">
                        <defs>
                            <linearGradient id="ndBar" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#5C7CFF" />
                                <stop offset="100%" stopColor="#7E6BFA" />
                            </linearGradient>
                        </defs>
                        {/* bars */}
                        <rect className="nd-bar nd-bar-1" x="30" y="88" width="35" height="82" rx="6" fill="url(#ndBar)" />
                        <rect className="nd-bar nd-bar-2" x="82" y="56" width="35" height="114" rx="6" fill="url(#ndBar)" />
                        <rect className="nd-bar nd-bar-3" x="134" y="104" width="35" height="66" rx="6" fill="url(#ndBar)" />
                        {/* ? badge */}
                        <circle cx="100" cy="100" r="28" fill="#ffffff" opacity="0.95" />
                        <text x="100" y="112" textAnchor="middle" fontSize="36" fill="#5C7CFF" fontWeight="700">?</text>
                    </svg>
                </div>

                {/* Headline + sub */}
                <h1 className="no-data-title mb-2">Revenue Data Not Available</h1>
                <p className="no-data-sub">
                    We don’t have revenue teardown information for <strong>{companyLabel}</strong> at this time.
                </p>

                {/* Optional back link (tiny, unobtrusive) */}
                <div className="mt-3 no-data-back">
                    <Link to="/clients_competitors" className="back_to_text">
                        <FeatherIcon.ArrowLeft className="back_icon" /> Back to Competitors
                    </Link>
                </div>
            </div>
        </div>
    );
}
